import { Platform } from 'react-native';


/** Maps common locale tags to our supported values */
const LOCALE_TO_VALUE: Record<string, string> = {
  en: 'en-GB',
  'en-US': 'en-GB',
  'en-GB': 'en-GB',
  'en-AU': 'en-GB',
  fr: 'fr',
  'fr-FR': 'fr',
  'fr-CA': 'fr',
  de: 'de',
  'de-DE': 'de',
  'de-AT': 'de',
  'de-CH': 'de',
  es: 'es',
  'es-ES': 'es',
  'es-MX': 'es',
  el: 'el',
  'el-GR': 'el',
  ja: 'ja',
  'ja-JP': 'ja',
  tk: 'tk', // Turkish
  tr: 'tk', // Turkish locale code is tr
  'tr-TR': 'tk',
  ar: 'ar',
  'ar-SA': 'ar',
  'ar-AE': 'ar',
  zh: 'zh',
  'zh-CN': 'zh',
  'zh-TW': 'zh',
  it: 'it',
  'it-IT': 'it',
  si: 'si', // Sinhala
  ko: 'ko',
  'ko-KR': 'ko',
  hi: 'hi',
  'hi-IN': 'hi',
  ml: 'ml',
  'ml-IN': 'ml',
  xh: 'xh',
  'xh-ZA': 'xh',
  zu: 'zu',
  'zu-ZA': 'zu',
  ur: 'ur',
  'ur-PK': 'ur',
  fil: 'fil',
  'fil-PH': 'fil',
  ms: 'ms',
  'ms-MY': 'ms',
  'ms-ID': 'ms',
  pt: 'pt',
  'pt-PT': 'pt',
  'pt-BR': 'pt',
};

function mapLocaleToSupported(tag: string): string | null {
  const lower = tag.toLowerCase().replace('_', '-');
  // Exact match
  if (LOCALE_TO_VALUE[lower]) return LOCALE_TO_VALUE[lower];
  // Base language (e.g. "en" from "en-IN")
  const base = lower.split('-')[0];
  if (LOCALE_TO_VALUE[base]) return LOCALE_TO_VALUE[base];
  return null;
}

/**
 * Detects the device's preferred language on native (iOS/Android) using expo-localization.
 * Returns a supported language value, or 'en-GB' as fallback.
 */
export function getDeviceLanguage(): string {
  if (Platform.OS === 'web') {
    try {
      const nav = typeof navigator !== 'undefined' ? navigator : null;
      const tag = nav?.language || (nav as any)?.userLanguage || 'en';
      return mapLocaleToSupported(tag) ?? 'en-GB';
    } catch {
      return 'en-GB';
    }
  }

  try {
    const { getLocales } = require('expo-localization');
    const locales = getLocales?.();
    const primary = locales?.[0];
    if (!primary?.languageTag && !primary?.languageCode) return 'en-GB';

    const tag = primary.languageTag ?? `${primary.languageCode}-${primary.regionCode ?? ''}`.replace(/-$/, '');
    const mapped = mapLocaleToSupported(tag);
    if (mapped) return mapped;

    const code = (primary.languageCode as string)?.toLowerCase?.();
    if (code && LOCALE_TO_VALUE[code]) return LOCALE_TO_VALUE[code];

    return 'en-GB';
  } catch {
    return 'en-GB';
  }
}
